import { configureStore, combineReducers, AnyAction, CombinedState } from '@reduxjs/toolkit';
import userReducer from './slices/user/userSlice';
import mainReducer from './slices/main/mainSlice';
import recaudacionPagoReducer from './slices/pages/RecaudacionPagoSlice';
import PaymentTypeReducer from './slices/paymentType/PaymentTypeSlice';
import PaymentUserReducer from './slices/paymentUser/PaymentUserSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

const persistConfig = {
  key: 'root',
  storage,
  whitelist:['userState', 'mainState', 'recaudacionPago', 'paymentType','paymentUser']
}

const combinedReducers = combineReducers({
  userState: userReducer,
  mainState: mainReducer,
  recaudacionPago: recaudacionPagoReducer,  
  paymentType: PaymentTypeReducer,
  paymentUser: PaymentUserReducer
})

const rootReducer = (state: CombinedState<any> | undefined, action: AnyAction) => {
  if (action.type === 'RESET') {
    state = undefined
  }
  return combinedReducers(state, action)
}

const persitedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persitedReducer,
  middleware: [thunk]
});

export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppDispatch = typeof store.dispatch;